import { StyleProp, ViewStyle } from 'react-native'

export interface VideoPlayerProps {
  source: { uri: string }
  aspectRatio?: number
  style?: StyleProp<ViewStyle>
  onFullscreenDismiss: () => void
}

export interface VideoPlayerHandle {
  play: () => void
  pause: () => void
  presentFullscreenPlayer: () => void
  dismissFullscreen: () => void
}

type VideoPlayer = React.ForwardRefExoticComponent<
  VideoPlayerProps & React.RefAttributes<VideoPlayerHandle>
>

export class VideoAdapter {
  Player: VideoPlayer

  constructor(methods: VideoAdapter) {
    this.Player = methods.Player
  }
}
